import React, { useContext } from "react";

/// React router dom
import {  Switch, Route } from "react-router-dom";


/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Home from "./components/Dashboard/Home";

import Setting from "./layouts/Setting";

/////Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";


/// pages
import viewpage from "./components/AppsMenu/public/viewpage";

/// App
import Security from "./components/AppsMenu/AppProfile/Security";
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import BasicActivation from "./components/AppsMenu/AppProfile/BasicActivation";
import IncomeHistory from "./components/AppsMenu/AppProfile/IncomeHistory";
import TransactionHistory from "./components/AppsMenu/AppProfile/TransactionHistory";
import Affiliate from "./components/AppsMenu/AppProfile/Affiliate";
import MySmartTeam from "./components/AppsMenu/AppProfile/MySmartTeam";
import Deposit from "./components/AppsMenu/AppProfile/Deposit";
import ProjectInvestment from "./components/AppsMenu/AppProfile/ProjectInvestment";
import BookingLand from "./components/AppsMenu/AppProfile/BookingLand";
import InvestmentLog from "./components/AppsMenu/AppProfile/InvestmentLog";
import LocalDepositView from "./components/deposit/LocalDepositView";
import CryptoDepositView from "./components/deposit/CryptoDepositView";
import Withdraw from "./components/AppsMenu/AppProfile/Withdraw";
import ChangePassword from "./components/AppsMenu/AppProfile/ChangePassword";
import IdentityVerify from "./components/AppsMenu/AppProfile/IdentityVerify";
import SupportTicket from "./components/AppsMenu/AppProfile/SupportTicket";
import CreateTicket from "./components/AppsMenu/AppProfile/CreateTicket";
import ViewTicket from "./components/AppsMenu/AppProfile/ViewTicket";
import ViewTeam from "./components/AppsMenu/AppProfile/viewteam";


    
import { ThemeContext } from "../context/ThemeContext";

const Markup = () => {
  const auth_token = localStorage.getItem('auth_token');
  const { menuToggle } = useContext(ThemeContext);

  const publicroutes = [
    { url: "ddd", component: Home }
  ];


  const authroutes = [
  /// Apps
    { url: "", component: Home },
    { url: "dashboard", component:  Home},
    { url: "view-page/:id/:titel", component: viewpage }, 
    { url: "security", component: Security },
    { url: "app-profile", component: AppProfile },
    { url: "basic-activation", component: BasicActivation },
    { url: "income-history", component: IncomeHistory },
    { url: "transaction-history", component: TransactionHistory},
    { url: "affiliate", component: Affiliate},
    { url: "my-smart-team", component: MySmartTeam },
    { url: "smart-module", component: ProjectInvestment },
    { url: "booking-land", component: BookingLand },
    { url: "investment-log", component: InvestmentLog },
    { url: "deposit", component: Deposit },
    { url: "local-deposit-view/:id/:slug", component: LocalDepositView },
    { url: "crypto-deposit-view/:id/:slug", component: CryptoDepositView },
    { url: "withdraw", component: Withdraw },
    { url: "change-password", component: ChangePassword },
    { url: "identity-verification", component: IdentityVerify },
    { url: "support-ticket", component: SupportTicket },
    { url: "create-ticket", component: CreateTicket },
    { url: "view-ticket/:id", component: ViewTicket },
    { url: "view-team/:id/:titel", component: ViewTeam }, 


  ];

  if (auth_token !== null) {
   var routes = authroutes;
  }else{
   var routes = publicroutes;
  }

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");
  return (
    <>
      <div
        id={`${!pagePath ? "main-wrapper" : ""}`}
        className={`${!pagePath ? "show" : "mh100vh"}  ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        {!pagePath && <Nav />}

        <div className={`${!pagePath ? "content-body" : ""}`}>
          <div
            className={`${!pagePath ? "container-fluid" : ""}`}
            style={{ minHeight: window.screen.height - 60, marginBottom : '60px' }}
          >
            <Switch>
              {routes.map((data, i) => (
                <Route
                  key={i}
                  exact
                  path={`/${data.url}`}
                  component={data.component}
                />
              ))}
            </Switch>
          </div>
        </div>
        {!pagePath && <Footer />}
      </div>
      <Setting />
    <ScrollToTop />
    </>
  );
};

export default Markup;
